import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, FileUploader, Popup, SelectBox, TextBox, Validator } from 'devextreme-react';
import { waybillService } from '../services/waybill-service';
import DateBox, { DateBoxTypes } from 'devextreme-react/cjs/date-box';
import { useNavigate, useParams } from 'react-router-dom';
import ArrayStore from 'devextreme/data/array_store';
import { alert, confirm } from 'devextreme/ui/dialog';
import { DataGridTypes, RequiredRule } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { left, right } from '@popperjs/core';
import { Config } from '@/core/config/config';
import moment from 'moment';
import OrderStatusCell from '@/projects/syncflow/order/components/order-status-celll';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import NumberBox, { NumberBoxTypes } from 'devextreme-react/cjs/number-box';


const WaybillAdd = () => {

    const [attachmentsData, setAttachmentsData] = useState<ArrayStore>();
    const dateLabel = { 'aria-label': 'Date' };
    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const validatorRefCustomer = useRef<Validator>(null);
    const validatorRefLocation = useRef<Validator>(null);
    const validatorRefOrders = useRef<Validator>(null);
    // const validatorRefInvoice = useRef<Validator>(null);

    let dueCalDate = new Date();
    dueCalDate.setDate(dueCalDate.getDate() + 7);




    const [waybillAddData, setinvoiceRecordingData] = useState<any>(
        {
            id: null, locationCode: null, vendorCode: null, comments: null, wayBillNo: null, orders: null, dueDate: null, wayBillDate: null, attachments: null, wayBillDetails: null, terms: null
        }
    );

    const [invoiceDetailData, setvendorSupplyData] = useState<any>();
    const [dueDate, setDueDateValue] = useState(dueCalDate);

    const onValueChangedDueDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setDueDateValue(e.value);
    }, []);

    const [wayBillDate, setWayBillDate] = useState(new Date());
    const onValueChangedWayBillDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setWayBillDate(e.value);
    }, []);

    const params = useParams();

    const [isNew, setIsNew] = useState(false);
    const getInvoice = async () => {
        setIsNew(!params.id ? true : false);

        const data = await waybillService.getWaybill(params ? params.id : -1);
        setvendorSupplyData(data)
        setCommentsValue(data.comments)

        var attachmentsData = data.attachments.split(',');
        var attachments: any[] = [];

        attachmentsData.forEach((element: any) => {
            attachments.push({ FileName: element })
        }); 
        setAttachmentsData(new ArrayStore({ data: attachments }));
    };

    const [store, setStore] = useState<CustomStore>();
    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["id"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])


    const onGetVendorSummaries = useCallback(async () => {
        if (orderId) {
            const orders = [];
            orders.push(orderId)
            const x = waybillService.orderLinesList(orders);
            return x;
        }
    }, []);



    const [vendorLookups] = useState(new CustomStore({
        load: waybillService.getVendorLookups,
    }));


    const [locationLookups] = useState(new CustomStore({
        load: waybillService.getLocationLookups,
    }));


    const [ordersLookups, setOrders] = useState();
    const getOrders = async (vendorValue: string, locationValue: string) => {
        setOrders(await waybillService.getOrderNoLookups(vendorValue, locationValue))
    };

    const onGetOrderData = useCallback(async () => {
        getInvoice();
        const x = await waybillService.getWaybillDetailList(params.id);
        return x;
    }, []);



    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };



    function onEditorPreparing(e: any) {
        if (e.parentType === "dataRow" && e.dataField === "receivedQty") {
            e.editorOptions.onValueChanged = function (args: any) {
                e.setValue && e.setValue(args.value, e)

                if (args.value != e.row.data.approvedQty) {
                    let result = alert(t("syncflow:msg_select_reason"), t("syncflow:ti_confirm"));
                    result.then(() => {
                        e.component.editCell(e.row.rowIndex, "wayBillReason");
                    });
                }
            };
        }
    }

    const [popupVisible, setPopupVisible] = useState(false);

    const hideInfo = useCallback(() => {
        setPopupVisible(false);
    }, [setPopupVisible]);

    const showInfo = useCallback(() => {
        let result = confirm(t("syncflow:msg_approve_reject_supplier"), t("syncflow:ti_confirm"));
        result.then((dialogResult) => {
            if (dialogResult) {
                setPopupVisible(true);
            }
        });
    }, [setPopupVisible]);

    const orderReasonsData = [
        { code: "1001", name: t('syncflow:lb_waybil_reason_status_1001') },
        { code: "2001", name: t('syncflow:lb_waybil_reason_status_2001') },
        { code: "3001", name: t('syncflow:lb_waybil_reason_status_3001') },
    ];

    const [orderReasonsLookup] = useState(new ArrayStore({
        key: 'code',
        data: orderReasonsData
    }));

    function validateApproveAndReason(e: any) {
        if (e.data.receivedQty != e.data.approvedQty && e.data.wayBillReason == undefined) { return false }
        else { return true }
    }



    const onSave = async () => {

        const validationCustomerResult = validatorRefCustomer.current?.instance.validate();
        const validationLocationResult = validatorRefLocation.current?.instance.validate();
        const validationOrdersResult = validatorRefOrders.current?.instance.validate();

        if (params.id ? true : false) {
            if (dataGridRef.current?.instance.hasEditData()) {
                let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
                result.then((dialogResult) => {
                    if (dialogResult) {
                        dataGridRef.current?.instance.saveEditData();
                    }
                });
            }
        } else {
            if (validationCustomerResult?.isValid && validationLocationResult?.isValid && validationOrdersResult?.isValid) {
                let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
                result.then((dialogResult) => {
                    if (dialogResult) {
                        dataGridRef.current?.instance.saveEditData();
                    }
                });
            }
        }



    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;

        if (params.id ? true : false) {
            invoiceDetailData.comments = commentsValue;
            waybillService.updateWaybillMaster(invoiceDetailData).then((response) => {
                toast.success(t("syncflow:msg_saved"));
                if (e.changes.length > 0) {
                    waybillService.updateWaybillDetail(e.changes).then((response) => {
                        dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                        toast.success(t("syncflow:msg_saved"));
                    });
                }
            });
        } else {
            waybillAddData.id = params ? params.id : null;
            waybillAddData.attachments = "";
            waybillAddData.comments = commentsValue;
            waybillAddData.vendorCode = vendorValueInsert;
            waybillAddData.dueDate = dueDate;
            waybillAddData.wayBillDate = wayBillDate;
            waybillAddData.wayBillNo = waybillValue;
            waybillAddData.orders = orderValue;
            waybillAddData.terms = termsValue;
            waybillAddData.locationCode = locationParams;
            waybillAddData.wayBillDetails = e.changes;

            waybillService.saveWaybill(waybillAddData).then((response) => {

                // const data = [];
                // data.push({ id: 0, accountId: 0, wayBillId: 0 })
                // waybillService.createInvoice(data);

                dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
                navigate(`/b2b/waybill-list`);
            });
        }
    }

    const navigate = useNavigate();
    const goToBack = () => {
        navigate(`/b2b/waybill-list`)
    }

    async function approveFunc() {

        let result = await confirm(t("syncflow:msg_approve_confirm_supplier"), t("syncflow:ti_confirm"));
        if (!result) return;

        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        //save
                        dataGridRef.current?.instance.refresh().then(x => {
                            dataGridRef.current?.instance.cancelEditData();
                            waybillService
                                .waybill_approve(invoiceDetailData?.id)
                                .then((response) => {
                                    toast.success(t("syncflow:msg_saved"));
                                    dataGridRef.current?.instance.refresh();
                                })
                        }
                        );
                    });
                }
                else {
                    dataGridRef.current?.instance.cancelEditData();
                    dataGridRef.current?.instance.refresh();
                    waybillService
                        .waybill_approve(invoiceDetailData?.id)
                        .then((response) => {
                            toast.success(t("syncflow:msg_saved"));
                            dataGridRef.current?.instance.refresh();
                        })
                }
            });
        }
        else {
            dataGridRef.current?.instance.refresh();
            waybillService
                .waybill_approve(invoiceDetailData?.id)
                .then((response) => {
                    toast.success(t("syncflow:msg_saved"));
                })
        }
    }

    let [reasonValue, setValue] = useState('');
    const nameLabel = { 'aria-label': 'Name' };
    const valueChanged = useCallback((data: TextBoxTypes.ValueChangedEvent) => {
        setValue(data.value);
    }, []);

    function declineFunc() {
        if (reasonValue != "") {
            waybillService.waybill_reject(invoiceDetailData != undefined ? invoiceDetailData.id : 0, reasonValue).then((response) => {
                dataGridRef.current?.instance.refresh();
                toast.success(t("syncflow:msg_saved"));
                hideInfo();
            })
        }
    }


    const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment-b2b/waybill/upload_waybill_attachments?WayBillId=` + params.id

    const [commentsValue, setCommentsValue] = useState("");
    const onValueChangedComments = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        setCommentsValue(e.value);
    }, []);

    let vendorValue: string;
    let locationValue: string;

    const [vendorValueInsert, setVendorValue] = useState("");
    const onValueChangedVendor = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        vendorValue = e.value;
        setVendorValue(e.value)
    }, []);

    const [locationParams, setLocationValue] = useState("");
    const onValueChangedLocation = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setLocationValue(e.value);
        locationValue = e.value;
        getOrders(vendorValue, locationValue);
    }, []);


    const [orderValue, setOrderValue] = useState("");
    let orderId: string = "";
    const onValueChangedOrderNo = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        if (e.value) {
            orderId = e.value;
            setOrderValue(e.value);
            dgVendorSummaryRef.current?.instance.refresh().then(x => showInfoOrders(0));
        }
    }, []);

    const [popupVisibleOrders, setPopupVisibleOrders] = useState(false);
    const showInfoOrders = useCallback((e: any) => {
        setPopupVisibleOrders(true);
    }, [setPopupVisibleOrders]);

    const hideInfoOrders = useCallback(() => {
        setPopupVisibleOrders(false);
    }, [setPopupVisibleOrders]);

    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        setSelectedRowKeys(args.selectedRowsData);
    };



    const newProductRow: any = {};
    const approveOrders = () => {
        selectedRowKeys.forEach((result: any) => {
            newProductRow.orderCode = result.orderCode;
            newProductRow.productCode = result.productCode;
            newProductRow.productName = result.productName;
            newProductRow.unit = result.unitCode;
            newProductRow.unitPrice = result.price;
            newProductRow.approvedQty = result.orderQty;
            newProductRow.receivedQty = result.orderQty;
            newProductRow.totalAmount = result.amount;

            dataGridRef.current?.instance.addRow();
        });
        hideInfoOrders();
    }


    const handleInitNewRow = async (e: any) => {
        e.data = newProductRow;
    };

    const [waybillValue, setWaybillValue] = useState("");
    const onValueChangedWaybillValue = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        setWaybillValue(e.value);
    }, []);


    const [termsValue, setTermsValue] = useState(7);
    const onValueChangedTermsValue = useCallback((e: NumberBoxTypes.ValueChangedEvent) => {
        setTermsValue(e.value);

        var d = new Date();
        d.setDate(d.getDate() + e.value);
        setDueDateValue(d)
    }, []);


    const onBeforeSend = async (e: any) => {
        e.request.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string))
    }

    const fileUploaderRef = useRef<FileUploader>(null);
    const [uploadedData, setUploadedData] = useState<any>();
    const [columns, setColumns] = useState<any>();
    const onUploaded = async (e: any) => {
        var response = JSON.parse(e.request.response);
        if (response.data) {
            setUploadedData(response.data);
            setColumns(Object.keys(response.data));
        }
        dataGridRef.current?.instance.refresh();
    }

    const onUploadError = async (e: any) => {
        setUploadedData([]);
        setColumns([]);
    }

    const goToTransactions = () => {
        showInfoTransactions(true);
    }

    const [popupVisibleTransactions, setPopupVisibleTransactions] = useState(false);
    const showInfoTransactions = useCallback((e: any) => {
        setPopupVisibleTransactions(true);
    }, [setPopupVisibleTransactions]);

    const hideInfoTransactions = useCallback(() => {
        setPopupVisibleTransactions(false);
    }, [setPopupVisibleTransactions]);

    return (
        <>

            <div id="container">

                <Popup
                    visible={popupVisible}
                    onHiding={hideInfo}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showCloseButton={false}
                    showTitle={true}
                    title="Information"
                    container="#container"
                    width={500}
                    height={200}
                >


                    <TextBox
                        onValueChanged={valueChanged}
                        inputAttr={nameLabel}
                        showClearButton={true}
                        placeholder={t("syncflow:msg_select_reason")}
                    >

                    </TextBox>

                    <div style={{ marginTop: 30, float: left }}>
                        <Button
                            text={t("syncflow:btn_reject")}
                            type="default"
                            stylingMode="contained"
                            icon="close"
                            onClick={declineFunc}
                        />
                    </div>

                    <div style={{ marginTop: 30, float: right }}>
                        <Button
                            text={t("syncflow:btn_cancel")}
                            type="default"
                            stylingMode="contained"
                            onClick={hideInfo}
                        />
                    </div>

                </Popup>
            </div>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_back")}
                        type="default"
                        icon="back"
                        stylingMode="contained"
                        onClick={goToBack}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t('syncflow:lb_attachments')}
                        type="default"
                        icon="add"
                        stylingMode="contained"
                        onClick={goToTransactions}
                        visible={invoiceDetailData?.wayBillStatus == "N" ? true : false}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                        visible={isNew ? true : (invoiceDetailData?.wayBillStatus != "N" ? false : true)}
                    />
                </div>
                {/* <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_approve")}
                        type="normal"
                        stylingMode="contained"
                        icon="check"
                        onClick={approveFunc}
                        style={{ backgroundColor: 'green', color: 'white' }}
                        visible={invoiceDetailData?.wayBillStatus != "N" ? false : true}
                    />
                </div> */}
                {/* <div className='col-auto'>
                    <Button
                        className='btnDecline'
                        text={t("syncflow:btn_reject")}
                        type="normal"
                        stylingMode="contained"
                        icon="close"
                        onClick={showInfo}
                        style={{ backgroundColor: 'red', color: 'white' }}
                        visible={invoiceDetailData?.wayBillStatus != "N" ? false : true}
                    />
                </div> */}
            </div>

            <div className="card-body py-3" style={{ display: params.id ? 'block' : 'none' }}>
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-120px">{t('syncflow:lb_customer')}</th>
                                <th className="min-w-120px">{t('syncflow:location')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_terms')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_waybill_no')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_orders')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_waybill_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_due_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_comments')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_product_count')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_approved_order_quantity')} / {t('syncflow:lb_recieved_qty')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.customerName}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.locationName}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.terms}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.wayBillNo}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.orderId}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(invoiceDetailData?.invoiceDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(invoiceDetailData?.dueDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{invoiceDetailData?.comments}</span></td>

                                <td><OrderStatusCell statusCode={invoiceDetailData?.wayBillStatus} isAllApproved={invoiceDetailData?.wayBillQty == invoiceDetailData?.receivedQty} label={(invoiceDetailData?.receivedProductCount + " / " + invoiceDetailData?.wayBillProductCount)} /></td>
                                <td><OrderStatusCell statusCode={invoiceDetailData?.wayBillStatus} isAllApproved={invoiceDetailData?.wayBillQty == invoiceDetailData?.receivedQty} label={(invoiceDetailData?.wayBillQty + " / " + invoiceDetailData?.receivedQty)} /></td>
                                <td><OrderStatusCell statusCode={invoiceDetailData?.wayBillStatus} isAllApproved={invoiceDetailData?.wayBillQty == invoiceDetailData?.receivedQty} label={t('syncflow:lb_order_supplier_status_' + invoiceDetailData?.wayBillStatus)} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <div style={{ display: params.id ? 'none' : 'block' }}>
                <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Vendor</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="vendorsLookups"
                                    onValueChanged={onValueChangedVendor}
                                    dataSource={vendorLookups}
                                    valueExpr="id"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} >
                                    <Validator ref={validatorRefCustomer}>
                                        <RequiredRule message="Confirm Vendor is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>


                    <label className="col-lg-1 col-form-label fw-bold fs-6">Location</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="locationLookups"
                                    onValueChanged={onValueChangedLocation}
                                    dataSource={locationLookups}
                                    valueExpr="id"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true}>
                                    <Validator ref={validatorRefLocation}>
                                        <RequiredRule message="Confirm Location is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>



                    <label className="col-lg-1 col-form-label fw-bold fs-6">Orders</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="ordersLookups"
                                    dataSource={ordersLookups}
                                    valueExpr="id"
                                    displayExpr="name"
                                    onValueChanged={onValueChangedOrderNo}
                                    searchEnabled={true}
                                    showClearButton={true}>
                                    <Validator ref={validatorRefOrders}>
                                        <RequiredRule message="Confirm Orders is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row">

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Terms</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                {/* <SelectBox
                                    name="vendorsLookups"
                                    onValueChanged={onValueChangedTermsValue}
                                    dataSource={termsLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} /> */}
                                <NumberBox defaultValue={7} onValueChanged={onValueChangedTermsValue} >
                                </NumberBox>
                            </div>
                        </div>
                    </div>


                    <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice No</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <TextBox onValueChanged={onValueChangedWaybillValue} value={waybillValue} >
                                </TextBox>
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice Date</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <DateBox
                                    defaultValue={wayBillDate}
                                    inputAttr={dateLabel}
                                    type="date"
                                    onValueChanged={onValueChangedWayBillDate}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">


                    <label className="col-lg-1 col-form-label fw-bold fs-6">Due Date</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <DateBox
                                    value={dueDate}
                                    inputAttr={dateLabel}
                                    type="date"
                                    onValueChanged={onValueChangedDueDate}
                                />
                            </div>
                        </div>
                    </div>


                    <label className="col-lg-1 col-form-label fw-bold fs-6">Comments</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <TextBox
                                    onValueChanged={onValueChangedComments}
                                    value={commentsValue} />
                            </div>
                        </div>
                    </div> 
                </div>
            </div>





            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    onEditorPreparing={onEditorPreparing}
                    onSaving={onSaving}
                    onInitNewRow={handleInitNewRow}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'orderCode',
                            caption: "Order No",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: "Product Name",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unit',
                            caption: "Unit",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        // {
                        //     dataField: 'unitPrice',
                        //     caption: "Unit Price",
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     format: { style: "currency", currency: "USD", useGrouping: true }
                        // },
                        {
                            dataField: 'approvedQty',
                            caption: "Approved Qty",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'receivedQty',
                            caption: "Received Qty",
                            allowFiltering: true,
                            allowEditing: false,
                            // visible: params.id ? true : false
                        },
                        {
                            dataField: 'wayBillReason',
                            caption: t('syncflow:lb_order_line_reason_name'),
                            allowFiltering: true,
                            allowEditing: false,
                            lookup: {
                                dataSource: orderReasonsLookup,
                                valueExpr: "code",
                                displayExpr: "name"
                            },
                            // visible: params.id ? true : false
                        },
                        // {
                        //     dataField: 'totalAmount',
                        //     caption: "Total Amount",
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     format: { style: "currency", currency: "USD", useGrouping: true },
                        //     calculateCellValue: renderGridCell,
                        // },
                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisibleOrders}
                onHiding={hideInfoOrders}
                title="Order products list"
                showTitle={true}
                width={1200}
                height={740}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_approve")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={approveOrders}
                        />
                    </div>
                </div>
                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,

                    }}
                    columns={[
                        {
                            dataField: 'productCode',
                            caption: 'Product Code',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: 'Product Name',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unitCode',
                            caption: 'Unit Code',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'priceCurrency',
                            caption: 'Price Currency',
                            allowFiltering: false,
                            allowEditing: false,
                        },

                        {
                            dataField: 'price',
                            caption: 'Price',
                            allowFiltering: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'orderQty',
                            caption: 'Order Qty',
                            allowFiltering: false,
                            allowEditing: false,
                        }
                    ]}
                />
            </Popup>

            <Popup
                visible={popupVisibleTransactions}
                onHiding={hideInfoTransactions}
                title={t('syncflow:lb_attachments')}
                showTitle={true}
                width={800}
                height={800}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className="row"> 
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="fv-row">
                                <FileUploader
                                    ref={fileUploaderRef}
                                    name="files"
                                    uploadMode="instantly"
                                    selectButtonText="Upload pdf or image"
                                    labelText=""
                                    multiple={true}
                                    accept=".jpg,.jpeg,.pdf"
                                    onBeforeSend={onBeforeSend}
                                    onUploadError={onUploadError}
                                    onUploaded={onUploaded}
                                    uploadUrl={uploadUrl}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <DataGridWrapper
                    // props={{ ref: dgVendorSummaryRef }}
                    datasource={attachmentsData}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    // selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: false,

                    }}
                    columns={[
                        {
                            dataField: 'FileName',
                            caption: 'File Name',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            // caption: "File",
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t('syncflow:lb_download')}
                                        type="default"
                                        icon='download'
                                        stylingMode="contained"
                                        onClick={() => goToDownload(params ? params.id : -1, data.key.FileName)}
                                    />
                                );
                            },
                        }
                    ]}
                />

            </Popup>

        </>


    )
}
const goToDownload = (id: any, fileName: string) => {
    waybillService.getDownloadWaybillPdf(id, fileName);
}
export default WaybillAdd